import {
  LanguageSwitcherSelectors,
  SearchSelectors,
  UserContextSelectors
} from "../../selectors";
import { call, debounce, fork, put, select } from "redux-saga/effects";
import { DebounceConstants } from "../../../constants";
import { SearchActionConstants } from "../../action-constants";
import { SearchActionCreators } from "../../action-creators";
import { SearchApi } from "../../api";

export let CancelTokens = [];

function* search(action) {
  const searchTerm = action.payload;

  if (!searchTerm || searchTerm.length < 2) {
    if (!searchTerm) yield put(SearchActionCreators.clearResults());

    return;
  }

  const brand = yield select(UserContextSelectors.brandId);
  const country = yield select(UserContextSelectors.userCountry);
  const lang = yield select(LanguageSwitcherSelectors.lang);
  const searchUrl = yield select(SearchSelectors.searchUrl);
  const currentUrl = new URL(window.location.href);
  const useclientprodapis = currentUrl.searchParams.get("useclientprodapis");

  let currentToken;

  const cancelToken = window.ucSDK.api.nonServiceInstance?.createCancelToken(
    c => {
      currentToken = c;
      CancelTokens.push(c);
    }
  );

  if (searchTerm) {
    const { response, errorResponse } = yield call(SearchApi.search, {
      searchTerm,
      lang,
      brand,
      country,
      useclientprodapis,
      cancelToken,
      searchUrl
    });
    const indexOfRequest = CancelTokens.indexOf(currentToken);

    if (response) {
      CancelTokens.slice(0, indexOfRequest).forEach(cancel => cancel());
      CancelTokens = CancelTokens.slice(indexOfRequest + 1);
      yield put(SearchActionCreators.requestFulfilled(response));
    } else if (errorResponse) {
      CancelTokens = CancelTokens.slice(indexOfRequest + 1);
      yield put(SearchActionCreators.requestError(errorResponse));
    }
  }
}

function* inputThrottle() {
  yield debounce(
    DebounceConstants.Search,
    SearchActionConstants.REQUEST,
    search
  );
}

export default [fork(inputThrottle)];
